import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';

import InputField from 'components/LoginForm/Input';
import countries from '../Register/registerCountriesData';
import states from '../Register/registerStatesData';

const RegisterExhibitor = (props) => (
  <div className="Register">
    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="email"
      fieldName="reg_email"
      fieldPlaceholder="Email"
      icon="at"
      focus
    />

    <InputField
      change={props.change}
      fieldType="password"
      fieldName="reg_password"
      fieldPlaceholder={i18n.translate('loginScreen.fields.password')}
      icon="key"
      line
    />

    <InputField
      change={props.change}
      fieldType="password"
      fieldName="reg_passwordConfirm"
      fieldPlaceholder={i18n.translate('loginScreen.fields.passwordConfirm')}
      icon="key"
      line
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_agency_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.agencyName')}
      icon="home"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_first_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.firstName')}
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_last_name"
      fieldPlaceholder={i18n.translate('loginScreen.fields.lastName')}
      icon="user"
    />

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_title"
      fieldPlaceholder={i18n.translate('loginScreen.fields.jobTitle')}
      icon="user"
    />

    <p htmlFor="reg_country" className="reg_country">
      {i18n.translate('loginScreen.fields.country')} *
    </p>
    <select id="reg_country" name="reg_country" onChange={props.change} value={props.reg_country}>
      <option value="" disabled selected>
        {i18n.translate('loginScreen.fields.select')}
      </option>
      {countries.map((c, index) => {
        const key = index;
        return (
          <option key={key} value={c.code}>
            {c.name}
          </option>
        );
      })}
    </select>

    <InputField
      change={props.change}
      fieldType="text"
      fieldName="reg_city"
      fieldPlaceholder={i18n.translate('loginScreen.fields.city')}
      icon="user"
    />

    {props.country !== 'US' && (
      <InputField
        change={props.change}
        fieldType="text"
        fieldName="reg_state"
        fieldPlaceholder={i18n.translate('loginScreen.2.fields.stateProvince')}
        icon="map"
        line
        defaultVal={props.reg_state}
        required
      />
    )}

    {props.country === 'US' && (
      <React.Fragment>
        <p htmlFor="reg_state" className="reg_state">
          {i18n.translate('loginScreen.2.fields.stateProvince')} *
        </p>
        <select id="reg_state" name="reg_state" onChange={props.change} value={props.state}>
          <option value="" disabled selected>
            {i18n.translate('loginScreen.2.fields.select')}
          </option>
          {states.map((c, index) => {
            const key = index;
            return (
              <option key={key} value={c.value}>
                {c.label}
              </option>
            );
          })}
        </select>
      </React.Fragment>
    )}
    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="text"
      fieldName="reg_zip_code"
      fieldPlaceholder={i18n.translate('loginScreen.fields.zipCode')}
      icon="map"
    />

    <InputField
      defaultVal={props.defaultVal}
      change={props.change}
      fieldType="tel"
      fieldName="reg_phone_number"
      fieldPlaceholder={i18n.translate('loginScreen.fields.phone')}
      icon="phone"
    />

    <h1>
      <b>Describe Your Business</b>
    </h1>
    <hr className="short" />

    <p htmlFor="reg_agency_business">What best describes Your business?</p>
    <select id="reg_agency_business" name="reg_agency_business" onChange={props.change}>
      <option value="" disabled selected>
        Please select an option below
      </option>
      <option value="Tourism Board">Tourism Board</option>
      <option value="DMO/CVB">DMO/CVB</option>
      <option value="Accommodation">Accommodation</option>
      <option value="Attraction">Attraction</option>
      <option value="Tour Operator">Tour Operator</option>
      <option value="Cruise Line">Cruise Line</option>
      <option value="Agency">Agency</option>
      <option value="Rep Firm">Rep Firm</option>
      <option value="Other">Other</option>
      <option value="Not Applicable">Not Applicable</option>
    </select>

    <InputField
      change={props.change}
      fieldLabel="I am open to receiving additional email communications from the exhibitors whose booths I have visited during the show, and show sponsors"
      fieldName="marketing_opt_in"
      fieldType="checkbox"
      icon="clipboard-check"
      userSelect={false}
      line={false}
      title="I am open to receiving additional email communications from the exhibitors whose booths I have visited during the show, and show sponsors"
      defaultSelected
    />

    <div className="login__form--buttons">
      <button type="submit" onClick={props.submit} className="Email__input--button">
        {props.loadingAnimRegister ? (
          <span>
            <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
          </span>
        ) : (
          i18n.translate('loginScreen.register')
        )}
      </button>
    </div>
  </div>
);

export default RegisterExhibitor;

RegisterExhibitor.propTypes = {
  defaultVal: PropTypes.string,
  change: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnimRegister: PropTypes.bool.isRequired,
};

RegisterExhibitor.defaultProps = {
  defaultVal: '',
};
